import React, {
  FormEvent,
  FunctionComponent,
  useCallback,
  useState,
} from 'react';

import { CardList, SubmitButton, AddButton } from 'components';
import { FormGroup } from 'components/chroma';

import { getApiData } from 'scenes/common/helpers/apiData';

import analytics from 'scenes/motor/analytics';
import { PolicyHolder, MotorFullPageProps } from 'scenes/motor/types';
import {
  getPolicyHolders,
  isPolicyIssuedToBusiness,
} from 'scenes/motor/selectors';

import { PolicyHolderCard } from './PolicyHolderCard';

const anySelected = (items: PolicyHolder[]): boolean =>
  items.some((policyHolder) => policyHolder.isSelected);

export const AddPolicyHolderStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  referenceData,
  onNextNoAutoFormMerge,
  onNext,
}) => {
  const [policyHolders, setPolicyHolders] = useState(
    getPolicyHolders(funnelState)
  );
  const isBusinessPolicy = isPolicyIssuedToBusiness(funnelState);

  const onSubmit = useCallback(
    (event: FormEvent) => {
      onNext({ addPolicyHolder: false });
      event.preventDefault();
    },
    [onNext]
  );

  const addPolicyHolder = useCallback(() => {
    onNextNoAutoFormMerge({ addPolicyHolder: true });
    // onNext({ addPolicyHolder: true });
  }, [onNextNoAutoFormMerge]);

  const handleSelect = useCallback(
    (index: number) => {
      const copyPolicyHolders = [...policyHolders];
      copyPolicyHolders[index].isSelected = !copyPolicyHolders[index]
        .isSelected;
      setPolicyHolders(copyPolicyHolders);
    },
    [policyHolders]
  );

  return (
    <form onSubmit={onSubmit}>
      <FormGroup
        label={
          isBusinessPolicy
            ? 'Would you like to add any additional business contacts? (optional)'
            : 'Who are the policy holders?'
        }
        helpText={
          isBusinessPolicy
            ? 'The business contact is the individual authorised to make policy changes and lodge claims on behalf of the business.'
            : 'Please include the registered owner of the car as one of the policy holders.'
        }
      >
        <CardList marginBottom="1rem">
          {policyHolders.map((policyHolder, index) => (
            <PolicyHolderCard
              key={`${policyHolder.firstName}-${policyHolder.lastName}`}
              policyHolder={policyHolder}
              selected={policyHolder.isSelected === true}
              onClick={() => handleSelect(index)}
            />
          ))}
        </CardList>
        <AddButton
          onClick={() => {
            analytics().addPolicy(funnelState, getApiData(referenceData));
            addPolicyHolder();
          }}
        >
          {isBusinessPolicy
            ? 'Add a new business contact'
            : 'Add new policy holder'}
        </AddButton>
      </FormGroup>
      <SubmitButton enabled={anySelected(policyHolders) || isBusinessPolicy}>
        Next
      </SubmitButton>
    </form>
  );
};

export default AddPolicyHolderStep;
